import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DemandeSupportModel } from 'src/models/demandeSupportModel';
import { UtilisateurService } from './utilisateur.service';

@Injectable({
  providedIn: 'root'
})
export class AideSupportService {

  private baseUrl = environment.api_LMS + 'AideSupport';

  constructor(
    private http: HttpClient,
    private utilisateurService: UtilisateurService
  ) { }

  envoyerDemandeSupport(sujet: string, description: string): Observable<void> {
    const demande: DemandeSupportModel = {
      sujet: sujet,
      description: description,
      utilisateurId: this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId,
      entiteId: this.utilisateurService.entiteUtilisateurSelectionnee.entiteId
    };

    return this.http.post<void>(`${this.baseUrl}/EnvoyerDemandeSupport`, demande);
  }

  obtenirUrlTutoriel(nomFichier: string): Observable<string> {
    return this.http.get(`${this.baseUrl}/ObtenirUrlTutoriel`, {
      params: { nomFichier },
      responseType: 'text'
    });
  }
}
